import anime from 'animejs';

let animatingScroll = false;
const scrollTo = (el: HTMLElement, pos: number) => {
	if (animatingScroll) return;

	let scroll = { left: el.scrollLeft };

	animatingScroll = true;
	el.classList.add('slideshow__slides-scroll--no-snap');
	anime({
		targets: scroll,
		left: pos,
		duration: 200,
		easing: 'easeOutQuad',
		update() {
			el.scrollLeft = scroll.left;
		},
		complete() {
			animatingScroll = false;
			/*el.classList.remove('slideshow__slides-scroll--no-snap');*/
		},
	});
};

document.addEventListener('DOMContentLoaded', () => {
	const slideshowEls = document.querySelectorAll<HTMLElement>(
		'[data-slideshow]',
	);
	slideshowEls.forEach((slideshowEl) => {
		const scrollEl = slideshowEl.querySelector<HTMLElement>(
			'[data-slideshow-scroll]',
		);
		const slideNodes = slideshowEl.querySelectorAll<HTMLElement>(
			'[data-slide]',
		);
		const slideEls = Array.from(slideNodes);

		if (slideEls.length === 0 || scrollEl == null) return;

		/**
		 * Store slide widths for quick access
		 */

		let widths: number[];
		const updateWidths = () => {
			widths = slideEls.reduce<number[]>(
				(widths, slideEl, i) => {
					const styles = window.getComputedStyle(slideEl);
					const marginRight = parseInt(
						styles.getPropertyValue('margin-right'),
						10,
					);
					widths.push(widths[i] + slideEl.clientWidth + marginRight);
					return widths;
				},
				[0],
			);
		};
		updateWidths();

		window.addEventListener('resize', () => {
			updateWidths();
		});

		/**
		 * Update opacities on scroll
		 */

		let prevScrollLeft = 0;
		let direction: 'left' | 'right' = 'right';
		scrollEl.addEventListener(
			'scroll',
			() => {
				if (prevScrollLeft === 0 && nextButton) {
					nextButton.classList.remove('dir-button--wiggle');
				}

				const scrollLeft = scrollEl.scrollLeft;
				direction = prevScrollLeft < scrollLeft ? 'right' : 'left';

				slideEls.forEach((slideEl, i) => {
					const index = i + (direction === 'right' ? 0 : 1);
					const hidden =
						scrollLeft > widths[index] + (direction === 'right' ? 5 : -5);
					slideEl.classList.toggle('slideshow__slide--hidden', hidden);
				});

				prevScrollLeft = scrollLeft;
			},
			{ passive: true },
		);

		/**
		 * Hook up buttons
		 */

		const nextButton = slideshowEl.querySelector('[data-next-slide]');
		const prevButton = slideshowEl.querySelector('[data-prev-slide]');

		if (nextButton) {
			nextButton.classList.add('dir-button--wiggle');
		}

		let nextButtonDisabled = false;
		let prevButtonDisabled = false;

		const getCurrentIndex = () =>
			widths.findIndex((width) => width >= scrollEl.scrollLeft);

		nextButton?.addEventListener('click', () => {
			const nextPosition = widths[getCurrentIndex() + 1];
			if (nextPosition !== undefined) {
				direction = 'right';
				scrollTo(scrollEl, nextPosition);
			}
		});

		prevButton?.addEventListener('click', () => {
			const prevPosition = widths[getCurrentIndex() - 1];

			if (prevPosition !== undefined) {
				direction = 'left';
				scrollTo(scrollEl, prevPosition);
			}
		});

		const updateButtonDisabled = () => {
			const errorMargin = 5;
			const scrollLeft = scrollEl.scrollLeft;
			const reachedLeft = scrollLeft <= errorMargin;
			const reachedRight =
				scrollEl.scrollLeft >=
				scrollEl.scrollWidth - scrollEl.clientWidth - errorMargin;

			if (nextButton) {
				if (reachedRight && !nextButtonDisabled) {
					nextButton.setAttribute('disabled', 'disabled');
					nextButtonDisabled = true;
				} else if (!reachedRight && nextButtonDisabled) {
					nextButton.removeAttribute('disabled');
					nextButtonDisabled = false;
				}
			}

			if (prevButton) {
				if (reachedLeft && !prevButtonDisabled) {
					prevButton.setAttribute('disabled', 'disabled');
					prevButtonDisabled = true;
				} else if (!reachedLeft && prevButtonDisabled) {
					prevButton.removeAttribute('disabled');
					prevButtonDisabled = false;
				}
			}
		};
		updateButtonDisabled();

		scrollEl.addEventListener(
			'scroll',
			() => {
				updateButtonDisabled();
			},
			{ passive: true },
		);

		/**
		 * Disable back/forward navigation swipe when hovering a slideshow
		 */

		const setOverscrollBehavior = (
			behavior: CSSStyleDeclaration['overscrollBehaviorX'],
		) => {
			document.documentElement.style.overscrollBehaviorX = behavior; /* maybe not needed */
			document.body.style.overscrollBehaviorX = behavior;
		};

		scrollEl.addEventListener('mouseenter', () => {
			setOverscrollBehavior('none');
		});

		scrollEl.addEventListener('mouseleave', () => {
			setOverscrollBehavior('auto');
		});
	});
});
